import React from "react";
import * as Sentry from "@sentry/browser";
import IframeComm from "react-iframe-comm";
import { Form, Progress } from "semantic-ui-react";
import "./onboarding.scss";
import i18next from "i18next";
import { apiURL } from "../../config";
import { getScreenDistance } from "./screen-distances";

interface IProps {
  handleStateChange: (name: string, value: any) => any;
  previousState: any;
  screenSize: string;
}

const NEARLY_THERE = 0.1;

let reportedCamera = false;

export default class WebCamDistance extends React.Component<IProps> {
  // the postMessage data you want to send to your iframe
  // it will be send after the iframe has loaded
  postMessageData = { level: 1 };
  state = {
    GoodDistance: false,
    Distance: 0.0,
    min: getScreenDistance("").min,
    max: getScreenDistance("").max,
  };
  componentDidMount() {
    const { min, max } = getScreenDistance(this.props.screenSize);
    if (!this.props.previousState) return this.setState({ min, max });
    this.setState({ ...this.props.previousState, min, max });
  }

  private WebGazer() {
    const attributes = {
      src: `${apiURL}/HeadTracker`,
      width: "100%",
      height: "100%",
      frameBorder: 1, // show frame border just for fun...
      allow: "camera",
    };

    return (
      <div className="CameraIframe">
        <IframeComm attributes={attributes} postMessageData={this.postMessageData} handleReady={this.onReady} handleReceiveMessage={this.onReceiveMessage} />
      </div>
    );
  }
  onReceiveMessage = async (event: any) => {
    if (!event?.data || event?.data.payload) return;

    const payload = JSON.parse(event.data);
    if (payload.camera && !reportedCamera) {
      reportedCamera = true;
      Sentry.captureMessage(`vizygood camera: ${payload.camera} fov ${payload.fov}`, "info" as any);
    }

    const state = { ...this.state, Distance: payload.distance };
    state.GoodDistance = state.Distance >= state.min && state.Distance <= state.max;

    this.setState(state);
    await this.props.handleStateChange("WebCamDistance", { WebCamDistance: state });
  };

  // iframe has loaded
  onReady = () => {
    console.log("onReady");
  };
  render() {
    return (
      <Form className="ergonomie-form">
        {this.WebGazer()}
        <div style={{ width: "95%", margin: "auto" }}>
          <p style={{ maxWidth: "350px", margin: "20px auto" }}>{i18next.t("tests.ergonomics.webcamDistance1")}</p>
          <div>
            {" "}
            <Progress percent={this.GetProgress()} color={this.GetColor()}></Progress>
          </div>
          <p style={{ margin: "auto" }}>{this.GetMessage()}</p>
        </div>
      </Form>
    );
  }

  private GetProgress = (): number => {
    if (!this.state.max || !this.state.Distance) return 0;
    if (this.state.Distance < this.state.min) return Math.round((this.state.Distance / this.state.min) * 100);
    if (this.state.Distance > this.state.max) return Math.round((this.state.max / this.state.Distance) * 100);
    return 100;
  };
  private GetMessage = () => {
    if (this.state.Distance >= this.state.min && this.state.Distance <= this.state.max) {
      return i18next.t("tests.ergonomics.webcamDistance2");
    }
    if (this.state.Distance <= this.state.min) {
      return i18next.t("tests.ergonomics.webcamDistance3");
    }
    if (this.state.Distance > this.state.max) {
      return i18next.t("tests.ergonomics.webcamDistance4");
    }
  };
  private GetColor = (): "green" | "red" | "orange" | "yellow" | "olive" | "teal" | "blue" | "violet" | "purple" | "pink" | "brown" | "grey" | "black" | undefined => {
    if (this.state.Distance >= this.state.min && this.state.Distance <= this.state.max) return "green";
    if (this.state.Distance >= this.state.min * (1 - NEARLY_THERE) && this.state.Distance <= this.state.max * (1 + NEARLY_THERE)) return "orange";
    if (this.state.Distance < this.state.min) return "red";
    return "yellow";
  };
}
